import React, { useState } from 'react';
import {
    IconButton,
    Typography,
    Button,
    Paper,
    Grid,
    TextField,
    InputAdornment
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { smallScreenWidth } from '../constants/AppConstants';
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import AutocompleteDropDown from '../components/AutocompleteDropdown'
import fetchFromAthena from '../functions/FetchFromAthena'
import LoadingButton from '../components/LoadingButton'
import LengthOfServiceDisplay from '../components/LengthOfServiceDisplay';

const defaultHeaders = {
    company: null,
    employee: null,
    prm_job_code: null,
    prm_through_date: ''
}

export default function LengthOfService(props) {
    const { credentials } = props.fetchInitialData
    const [data, setData] = useState(null)
    const [headers, setHeaders] = useState(defaultHeaders)
    const [clearHeader, setClearHeader] = useState(false)
    const [isLoading, setLoading] = React.useState(false)

    const handleSubmit = async () => {
        console.log('handleSubmit called with headers:', headers)
        
        if (!headers.employee || !headers.company) {
            props.createSnack('Company and Employee are required', 'warning', 3000)
            return
        }
        
        if (!headers.prm_through_date) {
            props.createSnack('Through Date is required', 'warning', 3000)
            return
        }
        
        setLoading(true)

        const queries = ['employee_length_of_service']

        const data = await Promise.allSettled(
            queries.map(query =>
                fetchFromAthena({
                    queryName: query,
                    headers: {
                        company: headers.company,
                        employee: headers.employee,
                        prm_job_code: headers.prm_job_code,
                        prm_through_date: headers.prm_through_date
                    },
                    accessToken: credentials.user.accessToken,
                    credentials: credentials
                })
            )
        ).then(results => {
            return results
        })
        
        console.log('API response:', data)
        setData(data[0].value)
        setLoading(false)
    }

    return (
        <div style={{ padding: '1.5rem 0.5rem' }}>
            <IconButton
                style={{ borderRadius: '5px', position: 'absolute' }}
                size="small"
                onClick={() => props.history.push('/')}
                aria-label="delete"
            >
                <ArrowBackIcon />
                {props.fetchInitialData.credentials.appWidth > smallScreenWidth && 'Dashboard'}
            </IconButton>
            <Typography variant="h5" style={{ textAlign: 'center' }}>
                Length of Service
            </Typography>

            <div style={{ margin: '1rem' }}>
                <Paper
                    elevation={0}
                    style={{ marginTop: '2rem', width: '100%', padding: '1rem' }}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{ position: 'relative' }}>
                            <div style={{ margin: '0 1rem 0 0' }}>
                                <Grid
                                    container
                                    alignContent='center'
                                    alignItems='flex-start'
                                    spacing={3}
                                >
                                    <Grid item>
                                        <AutocompleteDropDown
                                            {...props}
                                            id={'company'}
                                            name={'company'}
                                            width='160px'
                                            key={`company-${clearHeader}`}
                                            required={true}
                                            variant='standard'
                                            label={'Company'}
                                            value={headers.company}
                                            category={'company'}
                                            screen={'employee'}
                                            onChange={val => setHeaders({ ...headers, company: val ? val.key_value : null })}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <ServerSideAutoCompletev2
                                            disabled={!headers.company}
                                            required={true}
                                            key={`employee-${clearHeader}`}
                                            id='employee'
                                            width='320px'
                                            label='Employee'
                                            accessToken={credentials.user.accessToken}
                                            error='No Employee found'
                                            variant='standard'
                                            handleChange={(id, hit) => {
                                                setHeaders({ ...headers, employee: id ? id : null })
                                            }}
                                            credentials={credentials}
                                            apiResource='autocomplete-sql'
                                            secondaryParams={{
                                                limit: 100,
                                                company: headers.company
                                            }}
                                            dontOpenOnFocus
                                        />
                                    </Grid>
                                    <Grid item>
                                        <AutocompleteDropDown
                                            {...props}
                                            disabled={!headers.company}
                                            required={true}
                                            id={'job-code'}
                                            name={'job-code'}
                                            width='250px'
                                            key={`prm_job_code-${clearHeader}`}
                                            variant='standard'
                                            label={'Job Code'}
                                            value={headers.prm_job_code}
                                            category={'job-code'}
                                            screen={'hr'}
                                            onChange={val => setHeaders({ ...headers, prm_job_code: val ? val.key_value : null })}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id='prm_through_date'
                                            key={`prm_through_date-${clearHeader}`}
                                            style={{ marginTop: '5px', width: '250px' }}
                                            type={'date'}
                                            disabled={!headers.company}
                                            required={true}
                                            label={'Through Date'}
                                            variant='standard'
                                            value={headers.prm_through_date || ''}
                                            fullWidth
                                            onChange={e => {
                                                setHeaders({
                                                    ...headers,
                                                    prm_through_date: !!e.target.value ? e.target.value : ''
                                                })
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position='start'>
                                                        <span />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                        </Grid>
                        <div style={{ marginTop: '1rem' }}>
                            <LoadingButton
                                disabled={!headers.company || !headers.employee || !headers.prm_through_date}
                                label='Submit'
                                isLoading={isLoading}
                                color='primaryVLButton'
                                fn={handleSubmit}
                            />
                            {!!(headers.company || headers.employee || headers.prm_job_code || headers.prm_through_date) && (
                                <Button
                                    onClick={() => {
                                        setClearHeader(!clearHeader)
                                        setHeaders(defaultHeaders)
                                    }}
                                    style={{ marginLeft: '0.5rem' }}
                                >
                                    Clear
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Paper>
                {!!data && (
                    <div style={{ marginTop: '1rem' }}>
                        <LengthOfServiceDisplay data={data} />
                    </div>
                )}

            </div>
        </div>
    );
}
